import {of} from 'rxjs';

export class ImageReader {
  static convertImage(image: any): any {
    if (image == null) {
      return null;
    }
    return window.atob(image);
  }

  static blobToData(blob: Blob) {
    if (blob.size == 0) {
      return of(null);
    }
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
}
